module.exports = __webpack_public_path__ + "img/logo_cidesa.78b0942.png";